import { GA4React } from "ga-4-react";

// const ga4react = new GA4React("G-0SPQ2Z9EE2").initialize();
const ga4react = new GA4React("G-KJ4SX813TM").initialize();

export interface AnalyticsData {
    path: string;
    search: string;
    title: string;
}

const trackPathForAnalytics = (data: AnalyticsData) => {
    const { path, search, title } = data;
    ga4react
        .then((ga) => {
            // console.log(path, search, title)
            ga.pageview(path, search, title);
        })
        .catch((err) => console.error(`Analytics failed: ${err}`));
};

export default trackPathForAnalytics;